module.exports = __webpack_public_path__ + "images/new-development-icon-6d1982891cd412967480c97453a8d0c1.svg";